var normalizeComponent = require("!./node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = null
/* template */
import __vue_template__ from "!!./node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-97e45088\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!./node_modules/vue-loader/lib/selector?type=template&index=0!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./Announcement.md"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader!../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!../Announcement.md
// module id = null
// module chunks = 